if (!customElements.get('enavi-trust-indicators-slider')) {
  class EnaviTrustIndicatorsSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      this.slider = new Swiper(this, {
        slidesPerView: 2,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          750: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: 3,
            loop: false,
          },
          990: {
            enabled: false,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: 6,
            loop: false,
          }
        }
      });
    }
  }

  customElements.define('enavi-trust-indicators-slider', EnaviTrustIndicatorsSlider);
}
